import React, { useContext } from 'react';
import { AccountContext } from '../../context';

const Security = () => {
  const { userData, handlePassWordForgotten } = useContext(AccountContext);
  return (
    <div
      data-name="security"
      className="manage-account-form-block mt-top-added w-form"
    >
      <form
        id="email-form-2"
        name="email-form-2"
        data-name="Email Form 2"
        method="get"
        className="manage-account-form security-account-form"
        data-wf-page-id="65aec9c9e13ed74d8bfffe77"
        data-wf-element-id="af75e9f0-f6d7-98f4-9c2b-f0690b382ff7"
      >
        <div className="w-layout-hflex-account-ui tabs-content align-right more-gap">
          <h5 className="heading">Reset Password</h5>
          <div className="text-block-53">
            Click on the link below to receive a reset password link to your
            email address
          </div>
          <div className="w-layout-hflex-account-ui flex-block-20">
            <a
              onClick={() => handlePassWordForgotten()}
              href="#"
              className="default-btn form-submit-btn no-width w-button"
            >
              Send Password Reset Link
            </a>
          </div>
        </div>
      </form>
      <div className="w-form-done">
        <div>Thank you! Your submission has been received!</div>
      </div>
      <div className="w-form-fail">
        <div>Oops! Something went wrong while submitting the form.</div>
      </div>
    </div>
  );
};

export default Security;
